//@flow
import React from "react";
import Scroll from "react-scroll";
import s from "./FobTable.less";
import {
  numberToFixed,
  varianceCost,
  varianceMinutes,
  styleClass,
  convertDecimalMin
} from "../../helpers";

type Props = {
  fobData: Object
};

const FobTable = (props: Props) => {
  const totalStandardMinutes = props.SummarySectionData 
                                && props.SummarySectionData["Labor Cost"].sectionSummary.subSections 
                                && parseFloat(props.SummarySectionData["Labor Cost"].sectionSummary.subSections.find(ele => ele.detail === "Total").std);

  const totalObservedMinutes = props.SummarySectionData 
                                && props.SummarySectionData["Labor Cost"].sectionSummary.subSections 
                                && parseFloat(props.SummarySectionData["Labor Cost"].sectionSummary.subSections.find(ele => ele.detail === "Total").obsv);

  return (
    <div className={`shadowBox ${s.tableWrapper}`}>
      <Scroll.Element name={"summary"} id={"summary"}>
        <h2 className={`${s.summaryHeader}`}>COST SUMMARY</h2>
      </Scroll.Element>
      <table className={`${s.fobTable}`}>
        <tbody>
          <tr>
            <th />
            <th>Target</th>
            <th>Actual</th>
            <th>Variance</th>
          </tr>
          <tr>
            <td>Material Cost</td>
            <td data-e2e="target-fob">
              {props.fobData["Target Material Cost"] !== ""
                ? "$" + numberToFixed(props.fobData["Target Material Cost"], 2)
                : "-"}
            </td>
            <td>
              ${numberToFixed(
                props.SummarySectionData &&
                  props.SummarySectionData["Material Cost"].sectionSummary.cost,
                2
              )}
            </td>
            <td
              style={styleClass(
                props.SummarySectionData &&
                  props.SummarySectionData["Material Cost"].sectionSummary.cost,
                props.fobData["Target Material Cost"]
              )}
              data-e2e="fob"
            >
              {" "}
              {varianceCost(
                props.SummarySectionData &&
                  props.SummarySectionData["Material Cost"].sectionSummary.cost,
                props.fobData["Target Material Cost"], ''
              )}
            </td>
          </tr>
          <tr>
            <td>Labor Cost</td>
            <td data-e2e="target-fob">
              {props.fobData["Target Labor Cost"] !== ""
                ? "$" + numberToFixed(props.fobData["Target Labor Cost"], 2)
                : "-"}
            </td>
            <td>
              ${numberToFixed(
                props.SummarySectionData &&
                  props.SummarySectionData["Labor Cost"].sectionSummary.cost,
                2
              )}
            </td>
            <td
              style={styleClass(
                props.SummarySectionData &&
                  props.SummarySectionData["Labor Cost"].sectionSummary.cost,
                props.fobData["Target Labor Cost"]
              )}
              data-e2e="fob"
            >
              {varianceCost(
                props.SummarySectionData &&
                  props.SummarySectionData["Labor Cost"].sectionSummary.cost,
                props.fobData["Target Labor Cost"], ''
              )}
            </td>
          </tr>
          <tr>
            <td>Overhead Cost</td>
            <td data-e2e="target-fob">
              {props.fobData["Target Overhead Cost"] !== ""
                ? "$" + numberToFixed(props.fobData["Target Overhead Cost"], 2)
                : "-"}
            </td>
            <td>
              ${numberToFixed(
                props.SummarySectionData &&
                  props.SummarySectionData["Overhead Cost"].sectionSummary.cost,
                2
              )}
            </td>
            <td
              style={styleClass(
                props.SummarySectionData &&
                  props.SummarySectionData["Overhead Cost"].sectionSummary.cost,
                props.fobData["Target Overhead Cost"]
              )}
              data-e2e="fob"
            >
              {varianceCost(
                props.SummarySectionData &&
                  props.SummarySectionData["Overhead Cost"].sectionSummary.cost,
                props.fobData["Target Overhead Cost"], ''
              )}
            </td>
          </tr>
          <tr>
            <td>Profit Cost</td>
            <td data-e2e="target-fob">
              {props.fobData["Target Profit Cost"] !== ""
                ? "$" + numberToFixed(props.fobData["Target Profit Cost"], 2)
                : "-"}
            </td>
            <td>
              ${numberToFixed(
                props.SummarySectionData &&
                  props.SummarySectionData["Profit Cost"].sectionSummary.cost,
                2
              )}
            </td>
            <td
              style={styleClass(
                props.SummarySectionData &&
                  props.SummarySectionData["Profit Cost"].sectionSummary.cost,
                props.fobData["Target Profit Cost"]
              )}
              data-e2e="fob"
            >
              {varianceCost(
                props.SummarySectionData &&
                  props.SummarySectionData["Profit Cost"].sectionSummary.cost,
                props.fobData["Target Profit Cost"], ''
              )}
            </td>
          </tr>
          <tr>
            <td>Other Cost</td>
            <td data-e2e="otherCostTarget">N/A</td>
            <td data-e2e="OtherCostActual">
              ${numberToFixed(
                props.SummarySectionData &&
                  props.SummarySectionData["Other Cost"].sectionSummary.cost,
                2
              )}
            </td>
            <td data-e2e="otherCostVariance" style={{ color: "black" }}>
              N/A
            </td>
          </tr>
          <tr>
            <td>FOB Cost w/o Tooling Cost</td>
            <td data-e2e="target-fob">{props.fobData["Target FOB"]
                ?  "$" + numberToFixed(props.fobData["Target FOB"], 2)
                : "-"}
              </td>
            <td data-e2e="fob">${numberToFixed(props.fobData["FOB"], 2)}</td>
            <td style={styleClass(props.fobData["FOB"], props.fobData["Target FOB"])}>
              {varianceCost(props.fobData["FOB"], props.fobData["Target FOB"], 'FOB')}
            </td>
          </tr>
          <tr>
            <td>Tooling Cost</td>
            <td data-e2e="target-tooling">
              {props.fobData["Target Tooling"]
                ? "$" + numberToFixed(props.fobData["Target Tooling"], 2)
                : "-"}
            </td>
            <td data-e2e="tooling">${numberToFixed(props.fobData["Tooling Cost"], 2)}</td>
            <td style={styleClass(props.fobData["Tooling Cost"], props.fobData["Target Tooling"])}>
              {varianceCost(props.fobData["Tooling Cost"], props.fobData["Target Tooling"], '')}
            </td>
          </tr>
          <tr>
            <td>FOB Cost + Tooling</td>
            <td data-e2e="target-fob-with-tooling">
              {props.fobData["Target FOB with Tooling"]
                ? "$" + numberToFixed(props.fobData["Target FOB with Tooling"], 2)
                : "$" +
                  convertDecimalMin(
                    (props.fobData["Target FOB"] ? props.fobData["Target FOB"] : 0) +
                      (props.fobData["Target Tooling"] ? props.fobData["Target Tooling"] : 0)
                  )}
            </td>
            <td data-e2e="fob-with-tooling">
              ${numberToFixed(props.fobData["FOB with Tooling"], 2)}
            </td>
            <td
              style={styleClass(
                props.fobData["FOB with Tooling"],
                props.fobData["Target FOB with Tooling"]
                  ? props.fobData["Target FOB with Tooling"]
                  : props.fobData["Target FOB"] + props.fobData["Target Tooling"]
              )}
            >
              {varianceCost(
                props.fobData["FOB with Tooling"],
                props.fobData["Target FOB"] + props.fobData["Target Tooling"], ''
              )}
            </td>
          </tr>
          <tr>
            <td>Duty Driver</td>
            <td>{props.fobData["DUTY DRIVER"]}</td>
            <td>{props.fobData["ACTUAL DUTY DRIVER"]}</td>
            <td
              style={
                props.fobData["DUTY DRIVER"] === props.fobData["ACTUAL DUTY DRIVER"]
                  ? { color: "green" }
                  : { color: "red" }
              }
            >
              {props.fobData["DUTY DRIVER"] !== "" || props.fobData["ACTUAL DUTY DRIVER"] !== ""
                ? props.fobData["DUTY DRIVER"] === props.fobData["ACTUAL DUTY DRIVER"]
                  ? "Match"
                  : "Mismatch"
                : ""}
            </td>
          </tr>
          <tr>
            <td>Total Standard Minutes</td>
            <td>
              {props.fobData["Total Standard Minutes"] !== ""
                ? convertDecimalMin(props.fobData["Total Standard Minutes"])
                : "-"}
            </td>
            <td>{convertDecimalMin(totalStandardMinutes)}</td>
            <td style={styleClass(totalStandardMinutes, props.fobData["Total Standard Minutes"])}>
              {varianceMinutes(totalStandardMinutes, props.fobData["Total Standard Minutes"])}
            </td>
          </tr>
          <tr>
            <td>Total Observed Minutes</td>
            <td>
              {props.fobData["Total Observed Minutes"] !== ""
                ? convertDecimalMin(props.fobData["Total Observed Minutes"])
                : "-"}
            </td>
            <td>{convertDecimalMin(totalObservedMinutes)}</td>
            <td style={styleClass(totalObservedMinutes, props.fobData["Total Observed Minutes"])}>
              {varianceMinutes(totalObservedMinutes, props.fobData["Total Observed Minutes"])}
            </td>
          </tr>
        </tbody>
      </table>
      {/*<h5>*/}
      {/*/!* TODO: fake fob date *!/*/}
      {/*<span className={`${s.footerInfo}`}>FOB Effective Date</span>*/}
      {/*<span data-e2e={'FOB-Effective-Date'}>*/}
      {/*: {props.fobData['FOB Effective Date']}*/}
      {/*</span>*/}
      {/*</h5>*/}
      {/*<h5>*/}
      {/*<span className={`${s.footerInfo}`}>Target Duty Driver</span>*/}
      {/*<span data-e2e={'Duty-Driver'}>: {props.fobData['DUTY DRIVER']} </span>*/}
      {/*</h5>*/}
      {/*<h5>*/}
      {/*<span className={`${s.footerInfo}`}>Actual Duty Driver</span>*/}
      {/*<span style={*/}
      {/*props.fobData['ACTUAL DUTY DRIVER'] !== props.fobData['DUTY DRIVER']*/}
      {/*? {color: 'rgb(215, 29, 79)'}*/}
      {/*: {color: 'black'}*/}
      {/*}*/}
      {/*data-e2e={'Actual-Duty-Driver'}>: {props.fobData['ACTUAL DUTY DRIVER']} </span>*/}
      {/*</h5>*/}
    </div>
  );
};

export default FobTable;



// WEBPACK FOOTER //
// ./src/components/FobTable/FobTable.js